import { render, staticRenderFns } from "./CustomerSelectedStats.vue?vue&type=template&id=673cf4c8&scoped=true"
import script from "./CustomerSelectedStats.vue?vue&type=script&lang=js"
export * from "./CustomerSelectedStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673cf4c8",
  null
  
)

export default component.exports